export {default} from '../../../core/components/Repository/FieldTextJoinAutocomplete';
